import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'

Vue.use(Router)

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    url: ['/user'], // 跟后台匹配
    children: [{
      path: 'user',
      component: () => import('@/views/appcenter/user'),
      name: '用户管理',
      meta: { title: '用户管理', icon: 'user' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/role', '/adminrole'],
    children: [{
      path: 'role',
      component: () => import('@/views/appcenter/role'),
      name: '角色管理',
      meta: { title: '角色管理', icon: 'dashboard' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/menu', '/adminmenu'],
    children: [{
      path: 'menu',
      component: () => import('@/views/menu'),
      name: '菜单管理',
      meta: { title: '菜单管理', icon: 'list' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/dept'],
    children: [{
      path: 'dept',
      component: () => import('@/views/appcenter/dept'),
      name: '部门管理',
      meta: { title: '部门管理', icon: 'peoples' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/dataperm'],
    children: [{
      path: 'dataperm',
      component: () => import('@/views/appcenter/dataperm'),
      name: '数据管理',
      meta: { title: '数据管理', icon: 'peoples' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/adminuser', '/appuser'],
    children: [{
      path: 'adminuser',
      component: () => import('@/views/adminuser'),
      name: '公司管理员',
      meta: { title: '公司管理员', icon: 'user' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/adminapp'],
    children: [{
      path: 'adminapp',
      component: () => import('@/views/adminapp'),
      name: '应用管理',
      meta: { title: '应用管理', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/company'],
    children: [{
      path: 'company',
      component: () => import('@/views/company'),
      name: '公司管理',
      meta: { title: '公司管理', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/dictionary'],
    children: [{
      path: 'dictionary',
      component: () => import('@/views/dictionary'),
      name: '数据字典',
      meta: { title: '数据字典', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/loginpage'],
    children: [{
      path: 'loginpage',
      component: () => import('@/views/loginpage'),
      name: '登录页面',
      meta: { title: '登录页面', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/cache'],
    children: [{
      path: 'cache',
      component: () => import('@/views/cache'),
      name: '缓存管理',
      meta: { title: '缓存管理', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/userimport'],
    children: [{
      path: 'userimport',
      component: () => import('@/views/userimport'),
      name: '用户导入',
      meta: { title: '用户导入', icon: 'example' }
    }]
  },
  {
    path: '',
    component: Layout,
    url: ['/infoFRAME', '/infoES', '/info009', '/infoPS'],
    children: [{
      path: 'info',
      component: () => import('@/views/info'),
      name: '个人信息',
      hidden: true,
      meta: { title: '个人信息' }
    }]
  }
]

export const defaultRouterMap = [
  { path: '*', redirect: '/404', hidden: true }
]

export const constantRouterMap = [
  { path: '/redirectlogin',
    component: () => import('@/views/redirectlogin')
  },
  { path: '/login/:params?',
    component: () => import('@/views/login')
  },
  { path: '/404',
    component: () => import('@/views/error/404')
  },
  { path: '/',
    component: () => import('@/views/welcome'),
    name: '应用选择',
    meta: {title: '应用选择', sign: 'welcome'}
  },
  { path: '/getAppToken',
    component: () => import('@/views/welcome/getAppToken'),
    name: '获取应用token',
    meta: {title: '获取应用token'}
  }
]

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js